import React from 'react';
import { StyleSheet } from 'react-native';
import { Colors, grid } from '@shared/styles';

export const UnvalidatedStyles = {
  form: {
    flex: 1,
    alignSelf: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
  } as React.CSSProperties,
};

export const Styles = StyleSheet.create({
  overlayContainer: {
    flex: 1,
    alignSelf: 'stretch',
    justifyContent: 'flex-end',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    zIndex: 10,
  },
  overlayBorder: {
    borderWidth: 2,
    borderColor: Colors.v2.green,
    borderStyle: 'dashed',
    borderRadius: grid(1),
  },
});
